<script>
  // # # # # # # # # # # # # #
  //
  //  ShortList module
  //
  // # # # # # # # # # # # # #

  // *** IMPORT
  import { Router, links, link } from "svelte-routing";
  import { fade } from "svelte/transition";

  // *** PROPS
  export let item = {};
  export let architecture = false;
  export let gallery = false;

  // *** VARIABLES
  let hover = false;
</script>

<style lang="scss">
  @import "../_variables.scss";

  .shortlist {
    $block: &;

    &__item {
      color: $black;
      border-bottom: none;
      @include normal-hover-state;

      a {
        display: inline-block;
      }
    }

    &__image {
      max-width: 60%;
      max-height: 70vh;
      position: fixed;
      top: 110px;
      opacity: 0;
      transition: opacity $fast-easing;

      &.active {
        transition: none;
        opacity: 1;
      }

      &.architecture {
        right: 15px;
      }

      &.gallery {
        left: 15px;
      }
    }
  }
</style>

<div class="shortlist__item">
  <a
    href={'/' + item.header.grandparent + '/' + item.header.parent + '/' + item.header.slug}
    on:mouseenter={() => {
      hover = true;
    }}
    on:mouseleave={() => {
      hover = false;
    }}>
    {item.header.title}
  </a>
</div>

<img
  src={item.header.featured_image.sizes.small.url}
  class="shortlist__image"
  class:architecture
  class:gallery
  class:active={hover}
  alt={item.header.title}
  out:fade />
